<template>
    <rkm-table
        :fields="fields"
        :items="data.form.atestados"
        sort-by="data"
        tag="div"
    >
        <template v-slot:cell(data)="row">
            {{ row.value | formatDate }}
        </template>
    </rkm-table>
</template>

<script>
import formats from '@/filters/formats'

export default {
    data: () => ({
        fields: [
            { key: 'data', label: 'Data', class: 'col-min', sortable: true },
            { key: 'unidade.nomeFantasia', label: 'Unidade de atendimento', sortable: true },
            { key: 'profissional.nome', label: 'Médico responsável', sortable: true },
        ],
    }),
    filters: {
        formatDate: formats.formatDate,
    },
    props: {
        data: { type: Object, required: true },
    },
}
</script>